<script setup>
    import MainHeader from './../../components/HeaderComponent.vue';
    import { getCurrentInstance } from 'vue';
    import { ref } from 'vue';
    import { useRouter } from 'vue-router';
    import { useSignupStore } from '@/stores/signup/signupStore';
    import { useLoginStore } from '@/stores/login/loginStore';
    import BaseInput from './../../components/BaseInputComponent.vue';
    import Utils from '@/commonProject/helpers/utils.js';
    import i18n from '@/common/i18n';
    import { inject } from 'vue';
    import { useButtonDisabledStore } from '@/stores/common/disabledStore';

    const app = getCurrentInstance();

    const router = useRouter();
    const loginStore = useLoginStore();
    const signupStore = useSignupStore();

    const authenticationCode = ref('');

    // メッセージダイアログ取得
    const { messageDialog } = inject('messageDialogKey');
    
    // ボタン連打ガード制御
    const disabledStore = useButtonDisabledStore();

    /**
     * サインアップ確認
     */
    async function checkAuthenticationCode() {
        // バリデーションチェック
        if (isValidationError()) {
            return;
        }
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();

        // 自己サインアップ2APIのリクエストボディを生成する。
        const requestBody = {
            VendorId: loginStore.getVendorId,
            SignupPk: signupStore.SignupPk,
            CfmCode: authenticationCode.value,
        };

        // 自己サインアップ2APIをコールする。
        const response = await signupStore.CompleteSignUpAction(app.appContext.config.globalProperties.$constProperties.BASE_API_URL_P, requestBody);

        if (response.success) {
            // Storeを初期化する。
            signupStore.SignupPk = '';

            // 取得したユーザーIDをStoreに格納する。
            signupStore.UserId = response.responseBody.UserId;

            // サインアップ完了画面へ遷移する。
            router.push({ name: 'signupComplete' });
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }
    /**
     * バリデーションチェック
     */
    function isValidationError() {
        // エラーメッセージを初期化する。
        let message = '';

        // 認証コード
        if (Utils.isNullEmpty(authenticationCode.value)) {
            message += i18n.global.t('signupConfirm.message.message1') + '\n';
        } else {
            if (Utils.checkLengthOfAuthenticationCode(authenticationCode.value)) {
                message += i18n.global.t('signupConfirm.message.message2') + '\n';
            }
            if (!Utils.isMatchPatternNumber(authenticationCode.value)) {
                message += i18n.global.t('signupConfirm.message.message3') + '\n';
            }
        }

        // エラーメッセージが存在する場合は、以降の処理に進ませないので、バリデーションチェック判定を返却する。
        if (!Utils.isNullEmpty(message)) {
            // エラーメッセージが存在する場合は、画面に表示する。
            messageDialog('error', message);
            return true;
        }

        return false;
    }
</script>

<template>
    <section id="main" class="bg login extra">
        <MainHeader />
        <div id="contents" class="medium">
            <h2>{{ $t('signupConfirm.parts.pageTitle1') }}</h2>
            <h3>{{ $t('signupConfirm.parts.pageInformation1') }}</h3>
            <section class="form">
                <dl>
                    <dt style="padding-top: 10px">
                        <span>{{ $t('signupConfirm.parts.dl1') }}</span>
                    </dt>
                    <dd>
                        <BaseInput v-model:input="authenticationCode" type="text" />
                    </dd>
                </dl>
            </section>
            <ul class="btnArea">
                <li>
                    <button type="button" id="btnNext" class="btnPrimary" @click="checkAuthenticationCode" :disabled="disabledStore.isDisabled">{{ $t('signupConfirm.parts.button1') }}</button>
                </li>
            </ul>
        </div>
    </section>
</template>

<style></style>
